import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';

export default function AsyncContentModal ({ requestURL, contentCb }) {
    const [show, setShow] = useState(false)
    const [content, setContent] = useState('')

    const [top, setTop] = useState(0)
    const display = show ? 'block' : 'none'
    
    const [id] = useState('randid_' + requestURL.replaceAll('/', '_') + Math.floor(Math.random() * 1000))
    const [buttonId] = useState(id+'-button')

    function moveModal() {
        // Move the box
        const element = document.getElementById(buttonId)
        if( ! element ) {
            // stuff's not initialized yet
            return
        }
        const position = element.getBoundingClientRect()
        const top = position.top + 300 < window.innerHeight ? position.top - 100 : window.innerHeight - 300
        setTop(top+'px')
    }
    
    useEffect(() => {
        async function getContent() {
            fetch(requestURL, { credentials: 'same-origin' })
                .then(function(response) {
                    return response.json()
                })
                .then(function(json) {
                    const c = contentCb(json)
                    setContent(c)
                })
        }
        if(show && content === '') {
            setContent((<i className="fa fa-refresh fa-spin fa-fw"></i>))
            getContent()
        }
    }, [show, content])
    
    useEffect(() => {
        function handleClickOutside(event) {
            // Close on any click
            setShow(false)
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [show])
    
    return (
        <span key={id}>
            <div className="modal modal-info" style={{display: display, top: top}} tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content async-content-modal-content">
                        <div className="modal-body">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
            <button id={buttonId}
                className="btn btn-link pull-right" type="button"
                onClick={() => { moveModal(); setShow(!show) }}>
                <i className="fa fa-info-circle" aria-hidden="true"></i>
            </button>
        </span>
    )
}
